import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  isLoading: true,
  colors: [],
  color: null,     
  success: false,
  error: null,
  message: null,
};

export const parentColorReducer = createReducer(initialState, (builder) => {
  builder
    .addCase("createColorParentRequest", (state) => {
      state.isLoading = true;
      state.success = false;
    })
    .addCase("createColorParentSuccess", (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.color = action.payload; 
    })
    .addCase("createColorParentFail", (state, action) => {
      state.isLoading = false;
      state.success = false;
      state.error = action.payload;
    })

    .addCase("getAllColorParentsRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("getAllColorParentsSuccess", (state, action) => {
      state.isLoading = false;
      state.colors = action.payload;
    })
    .addCase("getAllColorParentsFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase("getOneColorParentRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("getOneColorParentSuccess", (state, action) => {
      state.isLoading = false;
      state.color = action.payload;
    })
    .addCase("getOneColorParentFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    .addCase("updateColorParentRequest", (state) => {
      state.isLoading = true;
      state.success = false;
    })
    .addCase("updateColorParentSuccess", (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.color = action.payload;
    })
    .addCase("updateColorParentFail", (state, action) => {
      state.isLoading = false;
      state.success = false;
      state.error = action.payload;
    })

    .addCase("deleteColorParentRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("deleteColorParentSuccess", (state, action) => {
      state.isLoading = false;
      state.message = action.payload;
      state.success = true;
    })
    .addCase("deleteColorParentFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })
    .addCase("clearErrors", (state) => {
      state.error = null;
    });
});
